import { render, staticRenderFns } from "./MindWithJoyDataTable.vue?vue&type=template&id=54f067c6&scoped=true"
import script from "./MindWithJoyDataTable.vue?vue&type=script&lang=js"
export * from "./MindWithJoyDataTable.vue?vue&type=script&lang=js"
import style0 from "./MindWithJoyDataTable.vue?vue&type=style&index=0&id=54f067c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f067c6",
  null
  
)

export default component.exports